import { render, staticRenderFns } from "./error.vue?vue&type=template&id=3b52b9b6&scoped=true"
var script = {}
import style0 from "./error.vue?vue&type=style&index=0&id=3b52b9b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b52b9b6",
  null
  
)

export default component.exports